(function () {
  'use strict';

  function cost(plan, storeFee) {
    const months = 12;
    const contract = plan.min_contract_months || 0;
    let paid = Math.max(months, contract), extra = 0, exitApplied = false;
    if (contract > months) {
      const rule = (plan.early_exit || []).find(item => months <= item.until_month);
      if (rule) { paid = months; extra = rule.fee; exitApplied = true; }
      if (!exitApplied && plan.early_exit_per_month != null) {
        paid = months;
        extra = plan.early_exit_per_month * months + (plan.early_exit_base || 0);
      }
    }
    const initial = (plan.initial_fees || []).reduce((sum, fee) => sum + (fee.amount || 0), 0);
    const yearly = (plan.yearly_fees || []).reduce((sum, fee) => {
      const first = fee.first_charge_month || 1;
      return sum + (fee.amount || 0) * (paid < first ? 0 : 1 + Math.floor((paid - first) / 12));
    }, 0);
    const monthly = (plan.monthly_fee ? (storeFee || plan.monthly_fee) : 0) + (plan.maintenance_monthly || 0);
    return { monthly, initial, yearly, extra, paid, effective: (monthly * paid + initial + yearly + extra) / months };
  }

  function rank(data, plans) {
    const rows = [];
    data.stores.forEach(store => {
      let best;
      plans.filter(plan => plan.chain === store.chain).forEach(plan => {
        const price = cost(plan, store.monthly_fee);
        if (Number.isFinite(price.effective) && price.effective > 0 && (!best || price.effective < best.price.effective)) best = { plan, price };
      });
      if (best) rows.push({ brand: store.chain, name: store.chain + ' ' + store.store, city: store.city, url: store.url, plan: best.plan.plan, ...best.price });
    });
    (data.indie || []).filter(gym => gym.is24h && !gym.review_hold && gym.monthly && Number.isFinite(gym.monthly.v)).forEach(gym => {
      const price = cost({ monthly_fee: gym.monthly.v, initial_fees: [{ amount: gym.join?.v || 0 }], yearly_fees: [{ amount: gym.yearly?.v || 0 }] });
      if (price.effective > 0) rows.push({ brand: gym.chain || gym.brand || gym.name, name: gym.name, city: gym.city, url: gym.website, plan: '', ...price });
    });
    return rows.sort((a, b) => a.effective - b.effective);
  }

  const filtered = (rows, excluded) => rows.filter(row => !excluded.has(row.brand));
  if (typeof module !== 'undefined' && module.exports) module.exports = { cost, rank, filtered };
  if (typeof document === 'undefined') return;
  const esc = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);
  const yen = value => '¥' + Math.round(value).toLocaleString('ja-JP');
  const safeUrl = value => { try { const url = new URL(value); return /^https?:$/.test(url.protocol) ? url.href : ''; } catch { return ''; } };

  document.querySelectorAll('[data-gym-filter-pref]').forEach(async root => {
    if (root.dataset.gymFilterReady) return;
    root.dataset.gymFilterReady = '1';
    const article = root.querySelector('.fpc-art');
    const list = article?.querySelector('.fpc-art-list');
    const heading = list?.previousElementSibling;
    if (!list || heading?.tagName !== 'H2' || !heading.textContent.includes('実質月額ランキング')) return;
    const panel = document.createElement('div');
    panel.className = 'navi-gym-filter';
    panel.innerHTML = '<p class="navi-gym-filter__status" role="status">ブランド除外の準備中…</p>';
    list.before(panel);
    const status = panel.querySelector('[role="status"]');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const get = async url => { const res = await fetch(url, { signal: controller.signal }); if (!res.ok) throw new Error('fetch'); return res.json(); };
      const [data, prices] = await Promise.all([
        get('https://fitpeak-price-api.vercel.app/api/public/price-compare/gym-stores?pref=' + encodeURIComponent(root.dataset.gymFilterPref)),
        get(root.dataset.gymFilterPrices)
      ]);
      if (!Array.isArray(data.stores) || !Array.isArray(prices.gyms) || !prices.gyms.length) throw new Error('data');
      const rows = rank(data, prices.gyms);
      if (!rows.length) throw new Error('empty');
      const counts = new Map();
      rows.forEach(row => counts.set(row.brand, (counts.get(row.brand) || 0) + 1));
      const brands = [...counts.keys()].sort((a, b) => (b === 'chocoZAP') - (a === 'chocoZAP') || counts.get(b) - counts.get(a) || a.localeCompare(b, 'ja'));
      const excluded = new Set();
      panel.insertAdjacentHTML('afterbegin', '<details><summary>ブランドを除外する <span data-gym-filter-count>0件</span></summary><p>チェックしたブランドをランキングから除外します（複数選択可）。</p><fieldset><legend>除外するブランド</legend><div class="navi-gym-filter__choices">' + brands.map(brand => '<label><input type="checkbox" value="' + esc(brand) + '"><span>' + esc(brand) + ' <small>（' + counts.get(brand) + '店舗）</small></span></label>').join('') + '</div></fieldset></details><button type="button" data-gym-filter-reset disabled>除外をすべて解除</button><p class="navi-gym-filter__note">除外は以下のランキングに適用します。記事本文は公開時の比較です。</p>');
      const reset = panel.querySelector('[data-gym-filter-reset]');
      const count = panel.querySelector('[data-gym-filter-count]');
      const more = document.createElement('button');
      more.type = 'button';
      more.className = 'navi-gym-filter__more';
      list.after(more);
      let limit = 12;
      const render = () => {
        const selected = filtered(rows, excluded);
        const shown = selected.slice(0, limit);
        heading.textContent = root.dataset.gymFilterPref + 'の24時間ジム 実質月額ランキング（' + (excluded.size ? 'ブランド除外後・' : '') + '上位' + shown.length + '件）';
        count.textContent = excluded.size + '件';
        reset.disabled = !excluded.size;
        const excludedLabel = excluded.size ? '除外中：' + [...excluded].slice(0, 3).join('・') + (excluded.size > 3 ? ' ほか' + (excluded.size - 3) + '件' : '') + '。' : '';
        status.textContent = excludedLabel + (selected.length ? selected.length + '店舗が対象・実質月額が安い順に' + shown.length + '店舗を表示（12ヶ月利用）。' : '条件に合う店舗がありません。除外するブランドを減らしてください。');
        list.innerHTML = shown.map((row, index) => {
          const url = safeUrl(row.url);
          const detail = [row.monthly ? '月会費・月額管理費 ' + yen(row.monthly) : '年額払い', '入会金など ' + yen(row.initial), '年会費など ' + yen(row.yearly)];
          if (row.extra) detail.push('途中解約金 ' + yen(row.extra));
          if (row.paid > 12) detail.push(row.paid + 'ヶ月契約分を計上');
          return '<li class="fpc-art-row' + (index === 0 ? ' is-top' : '') + '"><span class="fpc-art-rank">' + (index + 1) + '</span><div class="fpc-art-main"><div class="fpc-art-name">' + esc(row.name) + '</div><div class="fpc-art-sub">' + esc([row.city, row.plan].filter(Boolean).join('・')) + '</div></div><div class="fpc-art-price"><b>' + yen(row.effective) + '</b><small>/月（実質）</small></div><div class="fpc-art-detail">' + esc(detail.join('・')) + '</div><div class="fpc-art-buy">' + (url ? '<a href="' + esc(url) + '" target="_blank" rel="nofollow noopener">公式サイト</a>' : '') + '<a href="https://www.google.com/maps/search/?api=1&amp;query=' + encodeURIComponent(row.name + ' ' + row.city) + '" target="_blank" rel="nofollow noopener">地図</a></div></li>';
        }).join('');
        more.hidden = selected.length <= limit;
        more.textContent = '次の' + Math.min(12, Math.max(0, selected.length - limit)) + '店舗を表示';
      };
      panel.addEventListener('change', event => {
        if (!event.target.matches('input[type="checkbox"]')) return;
        if (event.target.checked) excluded.add(event.target.value); else excluded.delete(event.target.value);
        limit = 12;
        render();
      });
      reset.addEventListener('click', () => {
        excluded.clear();
        panel.querySelectorAll('input').forEach(input => { input.checked = false; });
        limit = 12;
        render();
      });
      more.addEventListener('click', () => { limit += 12; render(); });
      const note = document.createElement('p');
      note.className = 'navi-gym-filter__note';
      note.textContent = '料金を確認できた24時間ジムを比較しています。店舗データ確認日：' + (data.checked_at || '不明') + '。料金プラン確認日：' + (prices.gyms_checked_at || '不明') + '。最新の条件は各店舗の公式サイトでご確認ください。';
      more.after(note);
      render();
    } catch {
      status.textContent = 'ブランド除外用のデータを取得できませんでした。記事公開時のランキングを表示しています。時間をおいて再読み込みしてください。';
    } finally {
      clearTimeout(timeout);
    }
  });
})();
